import { createRouter, createWebHashHistory, Router } from 'vue-router'
import { ROUTE_CALLBACK_OIDC, ROUTE_HOME, ROUTE_MAIN, ROUTE_CALLBACK_MSENTRA } from './constants'
import AppLayout from '@/layouts/AppLayout.vue'
import CallbackPageOidc from '@/pages/Callback/CallbackPageOidc.vue'
import CallbackPageMSEntra from '@/pages/Callback/CallbackPageMSEntra.vue'
import HomePage from '@/pages/HomePage.vue'
import { navigationGuard } from './navigationGuard'

export const getRouter = (): Router => {
  return createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/',
        name: ROUTE_MAIN,
        component: AppLayout,
        redirect: { name: ROUTE_HOME },
        beforeEnter: navigationGuard.checkThatUserIsLoggedIn,
        children: [
          {
            path: '/',
            name: ROUTE_HOME,
            component: HomePage
          },
          {
            path: '/home',
            redirect: { name: ROUTE_HOME }
          }
        ]
      },
      {
        path: '/callback',
        name: ROUTE_CALLBACK_OIDC,
        component: CallbackPageOidc
      },
      {
        path: '/code=:token(.*)',
        name: ROUTE_CALLBACK_MSENTRA,
        component: CallbackPageMSEntra
      }
    ]
  })
}
